module.exports = __webpack_public_path__ + "static/media/21ECLAC48.4d872a22.jpg";